import type { ModalAction, ModalActionKind } from './modal-container.types';

export const MODAL_DRAG_HANDLE_CLASS = 'modal-container-drag-handle';

export const MODAL_ACTION_ATTRIBUTE = 'data-modal-action';

export const MODAL_BODY_ATTRIBUTE = 'data-modal-body';

export const MODAL_CLOSE_ATTRIBUTE = 'data-modal-close';

// MUI Select renders an aria-hidden native input next to its combobox; the not() clauses skip it.
// Each field selector is prefixed on its own rather than wrapped in :is(), which jsdom cannot parse.
const BODY_FIELD_SELECTOR = [
  'input:not([type="hidden"]):not([disabled]):not([readonly]):not([aria-hidden="true"]):not([tabindex="-1"])',
  'textarea:not([disabled]):not([readonly])',
  'select:not([disabled])',
  '[contenteditable="true"]',
  '[role="combobox"]:not(input):not([aria-disabled="true"])',
  '[aria-haspopup="listbox"]:not([disabled])',
]
  .map((field) => `[${MODAL_BODY_ATTRIBUTE}] ${field}`)
  .join(', ');

export const isSubmitAction = (action: ModalAction) => action.kind !== 'secondary';

const actionSelector = (kind: ModalActionKind) => `[${MODAL_ACTION_ATTRIBUTE}="${kind}"]`;

export const getPrimaryActionButton = (step: HTMLElement) =>
  step.querySelector<HTMLElement>(`${actionSelector('primary')}, ${actionSelector('danger')}`);

/**
 * Where focus lands when a step opens: Cancel beside a danger action, so a reflex Enter never
 * deletes; else the first field; else the primary of a confirmation; else the X.
 */
export const getInitialFocusTarget = (step: HTMLElement) => {
  if (step.querySelector(actionSelector('danger'))) {
    return step.querySelector<HTMLElement>(actionSelector('secondary'));
  }

  return (
    step.querySelector<HTMLElement>(BODY_FIELD_SELECTOR) ??
    getPrimaryActionButton(step) ??
    step.querySelector<HTMLElement>(`[${MODAL_CLOSE_ATTRIBUTE}]`)
  );
};
